import { PetOnboarding } from './PetOnboarding';

interface AddPetModalProps {
  onClose: () => void;
}

export function AddPetModal({ onClose }: AddPetModalProps) {
  return <PetOnboarding onClose={onClose} initiatedBy="owner" />;
}